import React from 'react';
import type { IconPropsSVG } from './types';

export function MotionOff(props: IconPropsSVG): React.JSX.Element {
    return (
        <svg
            viewBox="0 0 24.986 24.986"
            {...props}
        >
            <g fill="currentColor">
                <path
                    fill="currentColor"
                    d="M17.548 17.961l-.771-.769s-1.225 1.305-1.304 1.305c-.081 0-1.308-1.305-1.308-1.305l-.771.769s1.306 1.198 1.306 1.308c0 .106-1.306 1.308-1.306 1.308l.771.767s1.217-1.305 1.308-1.305c.089 0 1.304 1.305 1.304 1.305l.771-.767s-1.307-1.218-1.307-1.308c.001-.092 1.307-1.308 1.307-1.308z"
                />
                <path
                    fill="currentColor"
                    d="M15.472 14.435a4.832 4.832 0 0 0 0 9.661 4.83 4.83 0 0 0 0-9.661zm0 8.913a4.083 4.083 0 0 1-4.081-4.082 4.079 4.079 0 0 1 4.081-4.081 4.083 4.083 0 0 1 0 8.163z"
                />
                <circle
                    fill="currentColor"
                    cx={10.06}
                    cy={2.207}
                    r={2.207}
                />
                <path
                    fill="currentColor"
                    d="M10.2 20.476v3.26l.009.009a1.25 1.25 0 0 0 1.251 1.238c.643 0 1.167-.487 1.236-1.11-.083-.052-.173-.093-.253-.146a5.425 5.425 0 0 1-2.243-3.251z"
                />
                <path
                    fill="currentColor"
                    d="M12.455 14.724c.08-.057.168-.097.253-.146l-.002-6.687h.606V12.945c0 .516.417.932.932.932a.931.931 0 0 0 .933-.932V7.51c-.206-2.42-3.013-2.385-3.013-2.385H7.74c-3.168.06-3.055 2.385-3.055 2.385l-.001 5.428h.003c-.002.014-.002.025-.002.04a.932.932 0 1 0 1.861 0l-.001-.04h.001V7.914h.584l-.007 15.811c0 .693.562 1.261 1.257 1.261s1.257-.565 1.257-1.261V13.523h.562v4.457a5.414 5.414 0 0 1 2.256-3.256z"
                />
            </g>
        </svg>
    );
}
